import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { AuthRightComponent } from '../../core/common_components/auth-right/auth-right.component';
import { assets } from '../../core/constants/assets.const';

@Component({
  selector: 'mindbase-auth',
  standalone: true,
  imports: [RouterOutlet, CommonModule, AuthRightComponent, RouterModule],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss'
})
export class AuthComponent {

  protected assetsConst = assets;
}
